import {
  Controller,
  Get,
  Post,
  Param,
  Body,
  Patch,
  UseGuards,
} from '@nestjs/common';
import { MonitoringsService } from './monitorings.service';
import { CreateMonitoringsDto, UpdateMonitoringsDto } from '@crm/dto';
import { ApiResponseInterface, MonitoringStatus, UserRole } from '@crm/interface';
import { AuthGuard } from '../guards/auth.guard';
import { RolesGuard } from '../guards/roles.guard';
import { Roles } from '../guards/roles.decorator';
import { IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';

class UpdateMonitoringStatusDto {
  @IsUUID()
  id!: string;

  @IsEnum(MonitoringStatus)
  status!: MonitoringStatus;

  @IsOptional()
  @IsString()
  updated_by_id?: string;
}

@Controller('monitorings')
export class MonitoringsController {
  constructor(private readonly monitoringsService: MonitoringsService) {}

  // ====== GET ALL MONITORINGS ======
  @Get()
  async getAll(): Promise<ApiResponseInterface> {
    return this.monitoringsService.getAll();
  }

  // ====== GET MONITORINGS FOR SUPERVISOR ======
  @Get('supervisor')
  async getForSupervisor(): Promise<ApiResponseInterface> {
    return this.monitoringsService.getForSupervisor();
  }

  // ====== GET MONITORINGS BY USER ID ======
  @Get('user/:userId')
  async getByUserId(@Param('userId') userId: string): Promise<ApiResponseInterface> {
    return this.monitoringsService.getByUserId(userId);
  }

  // ====== GET MONITORING BY ID ======
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.monitoringsService.getById(id);
  }

  // ====== CREATE NEW MONITORING ======
  @Post()
  async create(@Body() dto: CreateMonitoringsDto): Promise<ApiResponseInterface> {
    return this.monitoringsService.create(dto);
  }

  // ====== UPDATE STATUS (management + supervisor only) ======
  @Patch('update-status')
  @UseGuards(AuthGuard, RolesGuard)
  @Roles(UserRole.MANAGEMENT, UserRole.SUPERVISOR)
  async updateStatus(@Body() dto: UpdateMonitoringStatusDto): Promise<ApiResponseInterface> {
    return this.monitoringsService.updateStatus(dto.id, dto.status, dto.updated_by_id);
  }

  // ====== UPDATE MONITORING (all roles, does not update status) ======
  @Patch()
  async update(@Body() dto: UpdateMonitoringsDto): Promise<ApiResponseInterface> {
    return this.monitoringsService.update(dto);
  }

  // ====== SOFT DELETE MONITORING ======
  @Patch('soft-delete')
  async softDelete(@Body() dto: UpdateMonitoringsDto): Promise<ApiResponseInterface> {
    return this.monitoringsService.softDelete(dto);
  }
}
